import { useQuery } from 'react-query';
import { errorMessage } from '@api/messages';
import getUser from '../api';
import { UserDTO } from '../dtos/UserDTO';

export default function useGetUser() {
  return useQuery<UserDTO>(['getUser'], () => getUser(), {
    onError: error => {
      errorMessage({
        title: `User not found`,
        message: null,
        error,
      });
    },
  });
}
